import React from 'react'

import VAC_AlarmPopup from '@Components/VAC/alarm/VAC_AlarmPopup'
import usePopup from '@Hooks/popup/usePopup'
import { POPUP_TYPE } from '@Root/contants/popup'
import AlarmPopupFactory from '@Components/alarm/popup/AlarmPopupFactory'

const AlarmPopup: React.FC = () => {
  const { popup } = usePopup()

  const popupProps = {
    popupList: {
      [popup.key]: { ...popup, confirmText: '확인' },
    },
  }
  // const popupProps = {
  //   popupList: {
  // // 내놓은 매물이 맞습니다.
  // popup_1: {
  //   title: '매물이 확인되었습니다.',
  //   text: '확인 버튼을 누르시면 노출중인 매물 상세 페이지로 이동합니다.',
  //   confirmText: '확인',
  // },
  // // 요청 시 안내 팝업
  // popup_2: {
  //   title: '중개사무소에 요청사항을 전달하였습니다.',
  //   confirmText: '확인',
  // },
  // // 취소 시 확인 팝업
  // popup_3: {
  //   title: '매물 정보 수정 요청을 취소하시겠습니까?',
  //   confirmText: '확인',
  // },
  // // 매물을 내놓지 않았습니다.
  // popup_4: {
  //   title: '매물을 내놓지 않으셨나요?',
  //   text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출중인 모든 매물이 노출 종료로 변경됩니다.',
  //   confirmText: '확인',
  //   closeButton: true,
  // },
  // popup_5: {
  //   title: '동일 주소로 등록된 모든 매물이 노출 종료되었습니다.',
  //   confirmText: '확인',
  // },
  // // 매물이 거래 완료되었습니다.
  // popup_6: {
  //   title: '매물이 거래 완료되었나요?',
  //   text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출중인 모든 매물이 거래 완료로 변경됩니다.',
  //   confirmText: '확인',
  //   closeButton: true,
  // },
  // popup_7: {
  //   title: '동일 주소로 등록된 모든 매물이 거래 완료로 변경되었습니다.',
  //   confirmText: '확인',
  // },
  // // 매물이 노출 종료 된 경우
  // popup_8: {
  //   title: '매물이 노출 종료되어 매물 확인 페이지로 이동할 수 없습니다.',
  //   confirmText: '확인',
  // },
  // // 네, 거래되었습니다.
  // popup_9: {
  //   title: '매물의 거래가 완료되었나요?',
  //   text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출중인 모든 매물이 거래 완료로 변경됩니다.',
  //   confirmText: '확인',
  //   closeButton: true,
  // },
  // popup_10: {
  //   title: '동일 주소로 등록된 모든 매물이 거래 완료로 노출 종료되었습니다.',
  //   confirmText: '확인',
  // },
  // // 아니요, 아직 거래가 가능합니다.
  // popup_11: {
  //   title: '매물이 거래 중인가요?',
  //   text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출 중인 모든 매물이 계속 노출됩니다.',
  //   confirmText: '확인',
  //   closeButton: true,
  // },
  // popup_12: {
  //   title: '동일 주소로 등록된 모든 매물이 계속 노출됩니다.',
  //   confirmText: '확인',
  // },
  // // 거래 완료 취소하기
  // popup_13: {
  //   title: '매물이 거래 가능한가요?',
  //   text: '확인 버튼을 누르면 네이버페이 부동산에서 동일 주소로 노출 중인 모든 매물이 계속 노출됩니다.',
  //   confirmText: '확인',
  //   closeButton: true,
  // },
  // popup_14: {
  //   title: '동일 주소로 등록된 모든 매물이 계속 노출됩니다.',
  //   confirmText: '확인',
  // },
  // },
  // }

  if (popup.key === POPUP_TYPE.NONE) {
    return <VAC_AlarmPopup popupList={popupProps.popupList} isHidden={true} />
  }
  return <AlarmPopupFactory popupKey={popup.key} />
}

export default AlarmPopup
